// extracted by mini-css-extract-plugin
export var sliderRange = "_np-2";
export var sliderRoot = "_np-0";
export var sliderThumb = "_np-3";
export var sliderTrack = "_np-1";